<template>
  <div
    class="sf-dropdown2-item"
    :class="dropdownItemClasses"
    data-testid="dropdown-item"
    v-bind="$attrs"
    @click.stop.prevent="handleClick"
  >
    <span class="tw-inline-flex tw-flex-1">
      <slot name="icon" />
      <slot name="default" />
    </span>
    <span v-if="hasCheckmark" class="sf-pad-l-1 icon icon-check"></span>
  </div>
</template>
<script setup lang="ts">
import { computed } from 'vue'

// eslint-disable-next-line no-undef
defineOptions({
  name: 'SfDropdownItem',
})

interface DropdownProps {
  hasCheckmark?: boolean
  hasBorder?: boolean
  isDisabled?: boolean
  isSelected?: boolean
  isRounded?: boolean
  isShort?: boolean
  isTall?: boolean
  isWide?: boolean
  isWrapped?: boolean
  href?: string
}

const props = withDefaults(defineProps<DropdownProps>(), {
  href: undefined,
  isWrapped: true,
  hasBorder: true,
})

const emit =
  defineEmits<{
    click: [e: Event]
  }>()

const dropdownItemClasses = computed(() => {
  return {
    'sf-dropdown2-item--tall': props.isTall,
    'sf-disabled': props.isDisabled,
    'sf-pointer': !props.isDisabled,
    'sf-nowrap': !props.isWrapped,
    'sf-dropdown2-item--no-border': !props.hasBorder,
    'sf-dropdown2-item--selected': props.isSelected,
    'tw-py-2 tw-px-4': props.isShort,
    'tw-py-4 tw-px-6': props.isWide && props.isTall,
    'tw-rounded': props.isRounded,
  }
})

const handleClick = (e: Event) => {
  if (props.isDisabled) {
    return
  }
  emit('click', e)

  if (props.href) {
    window.Turbolinks.visit(props.href)
  }
}
</script>
